import "../../../routeTree.gen";
import { createFileRoute } from "@tanstack/react-router";
import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { getRouteIcon } from "@/utils/getRouteIconComponent";

export const Route = createFileRoute("/_authenticated/assets/")({
  component: Assets,
});

function Assets() {
  useBreadcrumb([
    {
      title: "Assets",
      href: "/assets",
      icon: getRouteIcon(MODULE_KEYS_MAP.assets),
    },
  ]);
  return <div>Work in progress</div>;
}
